import ApiClient from './ApiClient'

/**
 * Service for handling questionnaire import operations
 */
class CollectImportService {
  /**
   * Validate an Excel file for questionnaire import
   * @param {number} collectId - ID of the collect
   * @param {File} file - Excel file to validate
   * @returns {Promise} - Promise resolving validation result
   */
  static validateFile(collectId, file) {
    const formData = new FormData()
    formData.append('file', file)

    return ApiClient.postFormData(`/collects/${collectId}/import/validate`, formData)
      .then(response => this.transformValidationResult(response))
  }

  /**
   * Transform API response to JS format (snake_case to camelCase)
   * @private
   * @param {Object} result - API response
   * @returns {Object} - Transformed result
   */
  static transformValidationResult(result) {
    return {
      success: result.success,
      error: result.error,
      sectionsCount: result.sections_count,
      questionsCount: result.questions_count,
      errors: result.errors,
      sections: result.sections
    }
  }
}

export default CollectImportService
